var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatreon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62598 9.58997C8.62598 10.4761 8.80052 11.3536 9.13964 12.1723C9.47876 12.991 9.97582 13.7349 10.6024 14.3616C11.229 14.9882 11.9729 15.4852 12.7917 15.8243C13.6104 16.1635 14.4879 16.338 15.374 16.338C16.2602 16.338 17.1377 16.1635 17.9564 15.8243C18.7751 15.4852 19.519 14.9882 20.1456 14.3616C20.7722 13.7349 21.2693 12.991 21.6084 12.1723C21.9475 11.3536 22.1221 10.4761 22.1221 9.58997C22.1221 8.7038 21.9475 7.82631 21.6084 7.0076C21.2693 6.18889 20.7722 5.44499 20.1456 4.81838C19.519 4.19176 18.7751 3.6947 17.9564 3.35558C17.1377 3.01646 16.2602 2.84192 15.374 2.84192C14.4879 2.84192 13.6104 3.01646 12.7917 3.35558C11.9729 3.6947 11.229 4.19176 10.6024 4.81838C9.97582 5.44499 9.47876 6.18889 9.13964 7.0076C8.80052 7.82631 8.62598 8.7038 8.62598 9.58997ZM5.73396 2.84192H1.87793V21.158H5.73396V2.84192Z",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatreon);
export default __webpack_public_path__ + "static/media/patreon.1904e1b0eb9bde804f00811e803681bb.svg";
export { ForwardRef as ReactComponent };